import type { CopyShape } from "@tami/core/intl";

import type { FINANCE_SCRIPT_COPY_PT_BR } from "../finance-script.copy";

export const FINANCE_SCRIPT_COPY_EN_US: CopyShape<typeof FINANCE_SCRIPT_COPY_PT_BR> = {
  finIntro: {
    narrative: "Creator finances: see how much came in, how much went out and what you're still owed — no manual spreadsheet.",
  },
  finMain: {
    narrative: "Campaign income flows into your finances automatically. See everything that came in and went out this month.",
    callout: "Everything that came in, what's left in your pocket and your margin — all at a glance.",
  },
  finOverview1: {
    narrative: "Keep track of payment and due dates without losing a single invoice.",
  },
  finInvoicesOpen: {
    narrative: "Keep an eye on it: open the manager and see every income and expense for the month in a clear table.",
    callout: "Your money, sorted — search, export and track all your invoices.",
  },
  finInvoicesTable: {
    narrative: "Campaigns, expenses and one-off income — each with type, due date and pending or paid status.",
    callout: "Each row shows where it came from, how much it was and whether it's hit your account.",
  },
  finInvoicesStatus: {
    narrative: "Mark as paid or edit whenever you need — full control over what's still pending.",
    callout: "Status and installments in view — nothing slips through at month-end.",
  },
  finNewInvoiceOpen: {
    narrative: "Log new income or an expense in seconds — without leaving your finance dashboard.",
    callout: "New income or expense — a quick flow to record any transaction.",
  },
  finNewInvoiceDesc: {
    narrative: "Describe the entry: fee, gear, coffee or any other transaction from your day.",
    callout: "Name the entry — easy to find later in your invoice manager.",
  },
  finNewInvoiceMeta: {
    narrative: "Earned or spent? One-time or in installments? Date and type decide how it shows up in the report.",
    callout: "Type, frequency and date — Tãmi sorts your income and expenses automatically.",
  },
  finNewInvoiceAmount: {
    narrative: "Enter the amount and save — the entry lands in your manager and in this month's charts.",
    callout: "How much came in or went out — one click and done, no spreadsheet.",
  },
  finDetailed: {
    narrative: "Expenses, average deal size and campaign ROI — numbers that help you charge and negotiate better.",
    callout: "Find your average deal size, ROI and what's still waiting to be paid.",
  },
  finOverview2: {
    narrative: "Reviewing the month's invoices and checking off every transaction gets simple.",
  },
  finChartPlatform: {
    narrative: "Instagram, TikTok or YouTube — find out which network brought in the most revenue for the period.",
    callout: "Revenue by platform: see where your audience turns into money the most.",
  },
  finChartType: {
    narrative: "Reels, stories or long-form video — compare formats and double down on what pays off.",
    callout: "Content type vs. revenue — data to prioritize what you make.",
  },
  finChartBrands: {
    narrative: "See which brands invested the most in you — handy for renewing partnerships and setting prices.",
    callout: "Brands ranked by revenue — a clear history to negotiate your next campaign.",
  },
};
